export default "__VITE_ASSET__DOyPyyn3__"